import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, IntlShape } from 'react-intl';
import classnames from 'classnames';
import { RecordingType, ReplaysOptions } from '../../../../../../api/artifacts.dao';
import { InfoPopover } from '../../../../../global/info-popover/info-popover';
import { OERadioOptions } from '../../../../../global/oe-radio-options/oe-radio-options';
import { RichTextEditor } from '../../../../../global/rich-text-editor';
import { artifactMp4RecordingTypes, passportReplayStatusLabel } from '../../../../../../constants/artifacts.constants';
import { KnovioLabel } from '../../../../../../api/connections.dao';

export interface IRequestReplaysSettingsProps {
    intl: IntlShape;
    reviewRequired: boolean;
    setReviewRequired: (reviewRequired: boolean) => void;
    placeholderText: string;
    getPlaceholderTextLengthError: () => string;
    setPlaceholderText: (placeholderText: string) => void;
    recordingType: RecordingType;
    isWebinarConnectionExist: boolean;
    handleRecordingTypeDropdown: (type: RecordingType) => void;
}

const RequestReplaysSettings = observer(({
    intl,
    reviewRequired,
    setReviewRequired,
    placeholderText,
    getPlaceholderTextLengthError,
    setPlaceholderText,
    recordingType,
    isWebinarConnectionExist,
    handleRecordingTypeDropdown
}: IRequestReplaysSettingsProps) => {

    return (
        <section className='request-artifacts-section'>
            <div className='flex'>
                <div>
                    <h3 className='request-artifacts-popover-types-title'>
                        {
                            intl.formatMessage({
                                description: 'Text',
                                defaultMessage: 'Publish Options',
                                id: 'oe.artifacts.publishOptions'
                            })
                        }
                    </h3>
                    <div className='request-artifacts-popover-types flex'>
                        <OERadioOptions
                            options={[
                                {
                                    value: ReplaysOptions.PUBLISH_AUTOMATICALLY,
                                    label: passportReplayStatusLabel(intl)[ReplaysOptions.PUBLISH_AUTOMATICALLY],
                                },
                                {
                                    value: ReplaysOptions.REVIEW_REQUIRED,
                                    label: passportReplayStatusLabel(intl)[ReplaysOptions.REVIEW_REQUIRED],
                                }
                            ]}
                            value={reviewRequired ? ReplaysOptions.REVIEW_REQUIRED : ReplaysOptions.PUBLISH_AUTOMATICALLY}
                            onOptionToggle={(value: ReplaysOptions) => setReviewRequired(value === ReplaysOptions.REVIEW_REQUIRED)}
                            styles='request-artifacts-popover-types__options'
                        />
                    </div>
                </div>
                {<div className={classnames({ 'request-replays-review__hidden': !reviewRequired })}>
                    <div className='request-replays-review'>
                        <h3 className='m-bottom-5px'>
                            <FormattedMessage
                                id='oe.artifacts.placeholderText'
                                defaultMessage='Placeholder text'
                                description='Label text'
                            />

                        </h3>
                        <InfoPopover>
                            <FormattedMessage
                                id='oe.artifacts.infoReplaysReview'
                                defaultMessage={`The Placeholder Text will be displayed to the attendee in place of the ${KnovioLabel.OEStream} thumbnail,
                                until the Connection is Published.`}
                                description='Label text'
                            />
                        </InfoPopover>
                    </div>
                    <RichTextEditor
                        value={placeholderText}
                        onChange={(event, editor) => setPlaceholderText(editor.getData())}
                        validationError={getPlaceholderTextLengthError()}
                        className='request-replays-review__rich-text-editor'
                    />
                </div>
                }
                <div className='m-left-10px'>
                    <div className='request-artifacts-mp4-options'>
                        <h3 className='request-artifacts-popover-types-title m-bottom-5px'>
                            <FormattedMessage
                                id='oe.artifact.mp4RecordingTypesWebinar'
                                defaultMessage='MP4 Format (Webinar)'
                                description='Label text'
                            />

                        </h3>
                    </div>
                    <select
                        value={recordingType}
                        onChange={e => isWebinarConnectionExist ? handleRecordingTypeDropdown(e.target.value as RecordingType) : undefined}
                        className='oe-form-field__control'
                        disabled={!isWebinarConnectionExist}
                    >
                        {artifactMp4RecordingTypes(intl).map(({ value, label }) => <option value={value} key={value}>{label}</option>)}
                    </select>
                </div>
            </div>
        </section>
    );

});

export default RequestReplaysSettings;
